export default __webpack_public_path__ + "static/media/spinner.9bfded29.gif";